import { sanitizePlainText } from "./security";

export function validateOrderDraft({ title, description, price, daysNeeded }) {
  const errors = {};
  const normalizedTitle = sanitizePlainText(title, { maxLength: 120 });
  const normalizedDescription = sanitizePlainText(description, { maxLength: 250 });
  const numericPrice = Number(price);
  const numericDays = Number(daysNeeded);

  if (normalizedTitle.length < 10) {
    errors.title = "Use at least 10 characters for the order title.";
  }
  if (normalizedDescription.length < 100 || normalizedDescription.length > 250) {
    errors.description = "Use between 100 and 250 characters for the description.";
  }
  if (!Number.isFinite(numericPrice) || numericPrice < 5) {
    errors.price = "Order price must be at least $5.";
  }
  if (!Number.isInteger(numericDays) || numericDays < 1 || numericDays > 6) {
    errors.daysNeeded = "Choose a delivery time between 1 and 6 days.";
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    value: {
      title: normalizedTitle,
      description: normalizedDescription,
      price: numericPrice,
      daysNeeded: numericDays,
    },
  };
}
